import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import HomePageChangelogItem from './HomePageChangelogItem'
import Link from '../Link'
import LanguageContext from '../../contexts/languageContext'

const HomePageChangelog = ({ data }) => {
  const { t } = useTranslation()
  const { lang } = useContext(LanguageContext)

  const linkMap = useMemo(
    () => ({
      url: `/${lang}/changelog`,
      icon: ['fal', 'arrow-right'],
      text: t('homePage.changelog.internalLinkChangelog'),
    }),
    [t, lang]
  )

  return (
    <section className={`${styles.homePageChangelogWrapper} ${styles.homePageWrapper}`}>
      <div className={styles.homePageChangelogHeader}>
        <h1>{t('homePage.changelog.title')}</h1>
      </div>
      <div className={`${styles.homePageChangelogContent}`}>
        {data.edges.map((log, index) => {
          const { frontmatter, fields } = log.node
          return <HomePageChangelogItem key={index} frontmatter={frontmatter} fields={fields} />
        })}
        <div className={styles.homePageChangelogFooter}>
          <Link href={linkMap.url} icon={linkMap.icon}>
            {linkMap.text}
          </Link>
        </div>
      </div>
    </section>
  )
}

export default HomePageChangelog
